import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import { useDCContext } from "@src/context";
import { AppUtils } from "@src/utils";
import EventsTable from "@src/components/tables/operator/EventsTable";
import { useOperatorContext } from "@src/context/operatorContext";
import { PeriodDropDown, BackButton, Loader } from "@src/components/atoms";
import { default as SectionContainer } from "@src/pages/sharedSections/SectionContainer";
import OperatorHooks from "@src/context/hooks/operatorHooks";
import { trackActionActivity } from "../../utils/userActivityTracker";
import ErrorPage from "@src/components/layout/ErrorPage";

const EventsPage = () => {
  const { profile, selectedPeriod, setSelectedPeriod } = useOperatorContext();
  const { customer } = profile;
  const navigate = useNavigate();
  const { getDynamicReplacement } = useDCContext();

  useEffect(() => {
    if (!selectedPeriod) {
      const current = AppUtils.getCurrentPeriod(
        moment.utc(),
        customer.industry,
      );
      setSelectedPeriod(current);
    }
  }, []);

  const selected = AppUtils.getDateRangeFromPeriodKey(
    selectedPeriod?.groupKey ||
      selectedPeriod?.value ||
      moment.utc().format("YYYY-MM"),
  );
  //Goals
  const {
    data: { goalsData } = {},
    //isPending: goalsPending,
    error: goalsError,
  } = OperatorHooks.useOperatorGoals(profile?.operator?.id);
  //All events
  const {
    data: { events } = {},
    isPending: eventsPending,
    error: eventsError,
  } = OperatorHooks.useOperatorEvents(
    selected.from,
    selected.to,
    profile?.operator?.id,
  );

  const onEventClick = (id) => {
    trackActionActivity("HISTORY_EVENT_SELECTION", { eventId: id });
    navigate(`/dashboard/operator/events/${id}`);
  };

  if (!selectedPeriod || !selected?.from || !selected?.to) {
    return <Loader size="lg" />;
  }

  if (!profile) return <ErrorPage pageName={"events"} />;

  return (
    <div>
      <div className="flex flex-col md:flex-row mx-4 my-4 items-center relative">
        <div className="md:w-1/3 absolute md:static self-start">
          <BackButton trackingActionKey="HISTORY_BACK_BUTTON" />
        </div>
        <h1 className="text-2xl md:text-4xl m-0 h-14 md:h-auto flex justify-center items-center md:w-1/3 self-center">
          {getDynamicReplacement("captain__events_list__title", {}, "History")}
        </h1>
        {!!goalsData && goalsData.length > 0 && (
          <div className="w-full md:w-1/3 flex justify-center md:justify-end">
            <PeriodDropDown goalsData={goalsData ? goalsData : []} />
          </div>
        )}
      </div>

      {!!eventsPending ? (
        <div className="min-h-120">
          <div className="w-full h-full flex items-center justify-center">
            <Loader size="2xl" />
          </div>
        </div>
      ) : !!eventsError ? (
        <ErrorPage pageName={"events"} />
      ) : !!events && selectedPeriod ? (
        <div className="px-4 pb-4">
          <SectionContainer shadow={false}>
            {events.length > 0 ? (
              <EventsTable
                events={events.filter((ev) =>
                  moment
                    .utc(ev.ocurrenceDatetime)
                    .isBetween(
                      moment.utc(selected.from),
                      moment.utc(selected.to).endOf("day"),
                      null,
                      "[]",
                    ),
                )}
                onEventClick={onEventClick}
              />
            ) : (
              <div className="text-center py-4">
                {getDynamicReplacement(
                  "captain__events_list__no_events_for_period",
                  {},
                  "No events for this period",
                )}
              </div>
            )}
          </SectionContainer>
        </div>
      ) : (
        <div>
          {getDynamicReplacement(
            "captain__events_list__no_event_data",
            {},
            "No events data",
          )}
        </div>
      )}
    </div>
  );
};

export const eventsPageControls = {};

EventsPage.propTypes = AppUtils.getPropTypeFromControls(eventsPageControls);

export default EventsPage;
